import { epicConstants } from '../constants'
import { epicService } from '../../services'
import { request, success, failure } from './helper'

function saveAuthUser(payload) {
  const { state, code } = JSON.parse(payload)
  return dispatch => {
    dispatch(
      success(epicConstants.SAVE_AUTH_USER, {
        state,
        code,
      })
    )
  }
}

function removeAuthUser() {
  return dispatch => {
    epicService.removeUserTicket()
    return dispatch(success(epicConstants.REMOVE_AUTH_USER))
  }
}

function activateGame(contentId, couponCode) {
  const payload = {
    contentId,
    couponCode,
  }
  return async dispatch => {
    dispatch(request(epicConstants.ACTIVATE_GAME_REQUEST))
    try {
      const response = await epicService.activateGame(payload)
      return response
    } catch (error) {
      dispatch(removeAuthUser())
      dispatch(failure(epicConstants.ACTIVATE_GAME_FAILURE, error))
      throw error
    }
  }
}

function saveParsedHash(payload) {
  return async dispatch => {
    try {
      const { code } = payload
      if (!code) throw new Error()

      const epic_v1 = JSON.stringify({
        code,
      })

      epicService.saveUserTicket(epic_v1)
      return dispatch(success(epicConstants.SAVE_USER_TICKET_SUCCESS, { code }))
    } catch (err) {
      console.log(err)
      return dispatch(failure(epicConstants.SAVE_USER_TICKET_FAILURE, err))
    }
  }
}

export default {
  saveAuthUser,
  removeAuthUser,
  activateGame,
  saveParsedHash,
}
